import { eModelAsset, Game } from "../../../Game";
import { SwitchPosTargetController } from "../Controllers/SwitchPosController";
import { TargetBase } from "../Targets/Target";
import { eTrajDisMark, TrajectoryDisplayer } from "./TrajectoryDisplayer";



export class SwitchPosTarTrajDis extends TrajectoryDisplayer {
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(target: TargetBase): void {
        // Zobrazit znacku na pozicich terce
        let meshCreator = Game.planeMeshCreator;
        let tarPositions = (target.controller as SwitchPosTargetController).positions;
        let markCnt = tarPositions.length;
        let markPos = new pc.Vec3();
        let markData = TrajectoryDisplayer._marks[eTrajDisMark.cross];

        meshCreator.reset();

        (target.controller as SwitchPosTargetController).positions.forEach((pos: pc.Vec2): void => {
            meshCreator.addPlane(markPos.set(pos.x, pos.y, 0), markData.vertexOffsets, markData.vertexUVs);
        });

        meshCreator.calculateNormals();
        meshCreator.initMesh(TrajectoryDisplayer._mesh);

        super.showEnd(target);
    }
}